// src/pages/LoginPage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function LoginPage() {
    const nav = useNavigate();
    const { login } = useAuth();

    const [email, setEmail] = useState("admin@drovis.co.kr");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");

    async function onSubmit(e) {
        e.preventDefault();
        setErr("");
        setBusy(true);
        try {
            await login(email, password);
            nav("/upload", { replace: true });
        } catch (e2) {
            setErr(e2?.message || "login failed");
        } finally {
            setBusy(false);
        }
    }

    return (
        <div style={styles.wrap}>
            <div style={styles.card}>
                <div style={styles.title}>Drovis SaaS Demo</div>
                <div style={styles.sub}>Login → Upload → Jobs → Logout</div>

                <form onSubmit={onSubmit} style={{ marginTop: 14, display: "grid", gap: 10 }}>
                    <label style={styles.label}>Email</label>
                    <input style={styles.input} value={email} onChange={(e) => setEmail(e.target.value)} />

                    <label style={styles.label}>Password</label>
                    <input
                        style={styles.input}
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    {err ? <div style={styles.err}>{err}</div> : null}

                    <button style={styles.btn} disabled={busy}>
                        {busy ? "..." : "Login"}
                    </button>

                    <div style={styles.hint}>* 토큰 만료/401 발생 시 자동 로그아웃 후 로그인 화면으로 이동합니다.</div>
                </form>
            </div>
        </div>
    );
}

const styles = {
    wrap: { minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f3f4f6" },
    card: { width: 520, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 18, padding: 22 },
    title: { fontSize: 28, fontWeight: 900 },
    sub: { marginTop: 6, color: "#6b7280", fontSize: 14 },
    label: { fontSize: 13, color: "#6b7280" },
    input: { border: "1px solid #e5e7eb", borderRadius: 10, padding: "10px 12px" },
    btn: { border: "none", borderRadius: 12, padding: "10px 12px", background: "#111827", color: "#fff", cursor: "pointer" },
    err: { background: "#fee2e2", border: "1px solid #fecaca", color: "#b91c1c", padding: "10px 12px", borderRadius: 10 },
    hint: { marginTop: 4, color: "#6b7280", fontSize: 12 },
};
